export default function productFilters($container) {
    const $selectAll = $container.querySelector('#filtered-select');
    const $checkboxes = [...$container.querySelectorAll('input[name="filtered-ids"]')];

    const getSelected = () => $checkboxes.filter(checkbox => checkbox.checked);
    const getSelectedValues = () => getSelected().map(checkbox => checkbox.value);
    const setSelectedValues = values => $checkboxes.forEach(checkbox => checkbox.checked = values.includes(checkbox.value));

    $selectAll.addEventListener('change', event => $checkboxes.forEach(element => element.checked = event.target.checked));

    return {
        getSelectedValues,
        setSelectedValues
    };
}